<template>
  <div>
    <div class="content-box">
      <GraficoModalComponent
        v-if="current.id"
        :id="current.id"
        :modulo="'inv'"
        :path="'sal_traslado'"
      />
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <form @submit="guardar">
                <router-link
                  class="btn btn-sm btn-outline-dark"
                  :to="{ name: 'inventario-salida_traslado' }"
                >
                  <i class="fa fa-reply"></i>
                  Regresar
                </router-link>
                <h5 class="form-header">
                  Salida por Traslado #
                  <u>{{ current.numero }}</u>
                  &nbsp;
                  <div
                    class="badge"
                    :class="{
                      'badge-success': current.estado == 'A',
                      'badge-warning': current.estado == 'B',
                      'badge-danger': current.estado == '9',
                    }"
                  >
                    <i class="os-icon os-icon-ui-09"></i>
                    <span v-if="current.estado_str">
                      {{ current.estado_str }}
                    </span>
                    <span v-if="!current.estado_str">En Proceso</span>
                  </div>
                  <div class="st-meta float-right">
                    <div class="element-actions">
                      <button
                        type="button"
                        data-toggle="modal"
                        data-target="#modalLog"
                        class="btn btn-info"
                      >
                        <i class="fas fa-history"></i>
                        Log transacciónes
                      </button>
                      <button
                        :disabled="current.estado == 'A'"
                        class="btn btn-outline-dark"
                        @click="imprimir"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button>
                      &nbsp;
                      <button
                        :disabled="current.estado == 'A'"
                        class="btn btn-outline-primary"
                        @click="showModalViewEntradas"
                      >
                        <i class="fas fa-share-square"></i>
                        Ir a entrada
                      </button>
                      &nbsp;
                      <!--<div class="btn-group">
                        <button
                          aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-secondary dropdown-toggle"
                          data-toggle="dropdown"
                          type="button"
                        >
                          <i class="fa fa-cogs"></i>
                          Acciones
                        </button>
                        <div class="dropdown-menu dropdown-menu-right">
                          <button
                            class="dropdown-item"
                            :class="{ disabled: !(current.estado == 'B') }"
                            @click="abrir"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-unlock"></i>
                            Abrir Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="cerrar"
                            :disabled="!(current.estado == 'A')"
                            href="#"
                          >
                            <i class="fa fa-lock"></i>
                            Cerrar Operación
                          </button>
                          <button
                            class="dropdown-item"
                            @click="anular"
                            :disabled="!(current.estado != '9')"
                            href="#"
                          >
                            <i class="fa fa-archive"></i>
                            Anular Operación
                          </button>
                          <div class="dropdown-divider"></div>
                          <button
                            class="dropdown-item"
                            @click="generar_entrada"
                            href="#"
                          >
                            <i class="fa fa-paper-plane"></i>
                            Generar Traslado de Producto
                          </button>
                        </div>
                      </div> -->
                    </div>
                  </div>
                </h5>
                <small
                  v-if="current.errors && current.errors.detail"
                  class="form-text text-danger"
                  >{{ current.errors.detail }}</small
                >
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.tienda_origen &&
                            current.errors.tienda_origen.length > 0,
                        }"
                        >Tienda Origen</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.tienda_origen"
                        :disabled="current.id"
                      >
                        <option
                          v-for="(tienda, key) in tiendas"
                          :value="tienda.codigo"
                          :key="key"
                        >
                          {{ tienda.nombre }}
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.tienda_origen"
                        class="form-text text-danger"
                        >{{ current.errors.tienda_origen }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.tienda && current.errors.tienda.length > 0,
                        }"
                        >Tienda Destino</label
                      >
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.tienda_destino"
                        :disabled="current.id"
                      >
                        <option
                          v-for="(tienda, key) in tiendas"
                          :value="tienda.codigo"
                          :key="key"
                        >
                          {{ tienda.nombre }}
                        </option>
                      </select>
                      <small
                        v-if="current.errors && current.errors.tienda"
                        class="form-text text-danger"
                        >{{ current.errors.tienda[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label
                        v-bind:class="{
                          'text-danger':
                            current.errors.fecha && current.errors.fecha.length > 0,
                        }"
                        >Fecha</label
                      >
                      <input
                        v-model="current.fecha"
                        class="form-control"
                        placeholder="Fecha"
                        :disabled="true"
                        type="text"
                      />
                      <small
                        v-if="current.errors && current.errors.fecha"
                        class="form-text text-danger"
                        >{{ current.errors.fecha[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Tipo</label>
                      <select
                        class="form-control"
                        autofocus="autofocus"
                        v-model="current.tipo_traslado"
                        :disabled="current.id"
                      >
                        <option value="T">Traslado</option>
                        <option value="D">Devolucion</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label>Usuario</label>
                      <input
                        :disabled="true"
                        class="form-control"
                        v-model="current.usuario"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="table-responsive" v-if="current.id != null">
                  <table class="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>SKU</th>
                        <th>Producto</th>
                        <th>Posición</th>
                        <th v-if="current.estado_str == 'Entregado'" class="text-center">
                          Enviada
                        </th>
                        <th v-if="current.estado_str != 'Entregado'" class="text-center">
                          Cantidad
                        </th>
                        <th class="text-center">Recibida</th>
                        <th class="text-center">Inconsistencia</th>
                        <th class="text-center nowrap">Estado</th>
                        <th v-if="current.estado == 'A'" class="text-center">Opciones</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="detalle in current.salidatrasladod_set"
                        v-bind:key="detalle.id"
                      >
                        <td>{{ detalle.producto.sku }}</td>
                        <td>{{ detalle.producto.nombre }}</td>
                        <td>{{ detalle.posicion }}</td>
                        <td class="text-right bolder nowrap" style="font-weight: 500">
                          <span style="color: #0646bf">
                            <i class="fas fa-truck-loading"></i>
                            {{ detalle.enviada }}
                          </span>
                        </td>
                        <td class="text-right bolder nowrap" style="font-weight: 500">
                          <span class="text-success">
                            <i class="fas fa-plus"></i>
                            {{ detalle.recibida }}
                          </span>
                        </td>
                        <td class="text-right bolder nowrap" style="font-weight: 500">
                          <span
                            v-bind:class="{
                              'text-danger': detalle.inconsistencia > 0,
                            }"
                            >{{ detalle.inconsistencia }}</span
                          >
                        </td>
                        <td class="text-center">
                          <span
                            class="status-pill smaller green"
                            v-if="detalle.estado == 'A'"
                          ></span>
                          <span
                            class="status-pill smaller red"
                            v-if="detalle.estado == 'B'"
                          ></span>
                        </td>
                        <td
                          v-if="current.estado == 'A'"
                          class="text-center"
                          style="width: 200px"
                        >
                          <button
                            class="btn btn-sm btn-dark mr-1"
                            type="button"
                            v-if="current.estado == 'A'"
                            @click="editarDetalleShowmodal(detalle)"
                          >
                            <i class="fas fa-edit"></i>
                            Editar
                          </button>
                          <button
                            class="btn btn-sm btn-danger mr-1"
                            type="button"
                            v-if="current.estado == 'A'"
                            @click="deleteDetalle(detalle)"
                          >
                            <i class="fa fa-trash"></i>
                            Eliminar
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary"
                      @click="showModalAddDetail"
                      v-if="current.estado == 'A'"
                    >
                      <i class="fa fa-plus"></i>
                      Agregar Producto
                    </button>
                  </div>
                  <!-------------------- END - Basic Table -------------------->
                </div>
                <div class="form-buttons-w">
                  <!-- <button
                    class="btn btn-md btn-success"
                    v-if="current.id == null"
                    type="submit"
                  >
                    Guardar
                  </button> -->
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        aria-hidden="true"
        class="modal fade"
        id="modalModDetailSalida"
        role="dialog"
        tabindex="-1"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header faded smaller">
              <h5 class="modal-title">Modificar Producto</h5>
              <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Producto</label>
                      <input
                        v-model="currentDetalleMod.producto.sku"
                        class="form-control"
                        placeholder="Producto"
                        readonly="readonly"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Cantidad en Unidades</label>
                      <input
                        v-model="currentDetalleMod.cantidad"
                        class="form-control"
                        placeholder="Cantidad Unidades"
                        type="text"
                        style="text-align: center; font-size: 200%"
                      />
                      <small
                        v-if="
                          currentDetalleMod.errors && currentDetalleMod.errors.cantidad
                        "
                        class="form-text text-danger"
                        >{{ currentDetalleMod.errors.cantidad[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Lote</label>
                      <select
                        :disabled="true"
                        v-if="currentDetalleMod.productolote_set"
                        v-model="currentDetalleMod.producto_lote"
                        class="form-control"
                        autofocus="autofocus"
                      >
                        <option
                          v-for="detalle in currentDetalleMod.productolote_set"
                          :value="detalle"
                          v-bind:key="detalle.id"
                        >
                          Lote: {{ detalle.codigo_lote }} || Vence:
                          {{ detalle.fecha_vence }}
                        </option>
                      </select>
                      <small
                        v-if="
                          currentDetalleMod.errors &&
                          currentDetalleMod.errors.producto_lote
                        "
                        class="form-text text-danger"
                        >{{ currentDetalleMod.errors.producto_lote[0] }}</small
                      >
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label>Posicion</label>
                      <select
                        :disabled="true"
                        class="form-control"
                        autofocus="autofocus"
                        v-model="currentDetalleMod.posicion"
                      >
                        <option
                          v-for="(detalle, key) in posiciones"
                          :value="detalle.posicion_id"
                          :key="key"
                        >
                          {{ detalle.codigo_barra }}
                        </option>
                      </select>
                      <small
                        v-if="currentDetalle.errors && currentDetalle.errors.posicion"
                        class="form-text text-danger"
                        >{{ currentDetalle.errors.posicion }}</small
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" @click="editarDetalle" type="button">
                Agregar
              </button>
              <button
                class="btn btn-secondary"
                ref="cerrarModal"
                data-dismiss="modal"
                type="button"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAddDetailReqTraslado"
      role="dialog"
      tabindex="-1"
    >
      <form @submit="agregaDetalle" class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        currentDetalle.errors && currentDetalle.errors.length > 0,
                    }"
                  ></label>
                  <ProductoSelectComponentV2
                    @onChangeProducto="onChangeProducto"
                    :current="currentDetalle"
                  ></ProductoSelectComponentV2>
                  <small v-if="currentDetalle.errors" class="form-text text-danger">{{
                    currentDetalle.errors.detail
                  }}</small>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="form-group">
                  <label>Posicion</label>

                  <select
                    class="form-control"
                    autofocus="autofocus"
                    v-model="currentDetalle.posicion"
                    @input="$emit('input', $event.target.value)"
                  >
                    <option
                      v-for="(detalle, key) in posiciones"
                      :value="detalle.id"
                      :key="key"
                    >
                      {{ detalle.barra }}
                    </option>
                  </select>
                  <small
                    v-if="currentDetalle.errors && currentDetalle.errors.posicion"
                    class="form-text text-danger"
                    >{{ currentDetalle.errors.posicion[0] }}</small
                  >
                </div>
              </div>
              <div class="col-sm-12">
                Lotes:
                <select
                  v-model="currentDetalle.producto_lote"
                  v-if="
                    currentDetalle.producto != null &&
                    currentDetalle.producto.productolote_set
                  "
                  class="form-control"
                  autofocus="autofocus"
                >
                  <option
                    v-for="detalle in currentDetalle.producto.productolote_set"
                    :value="detalle.id"
                    v-bind:key="detalle.id"
                  >
                    Lote: {{ detalle.id }} || Fab: {{ detalle.fecha_fabricacion }} ||
                    Vence:
                    {{ detalle.fecha_vence }}
                  </option>
                </select>
                <small
                  v-if="currentDetalle.errors && currentDetalle.errors.producto_lote"
                  class="form-text text-danger"
                  >{{ currentDetalle.errors.producto_lote }}</small
                >
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label
                    v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.enviada &&
                        currentDetalle.errors.enviada.length > 0,
                    }"
                    >Cantidad en Unidades</label
                  >
                  <input
                    v-model="currentDetalle.enviada"
                    class="form-control"
                    placeholder="Cantidad"
                    type="text"
                    style="text-align: center; font-size: 200%"
                    v-bind:class="{
                      'is-invalid':
                        currentDetalle.errors.enviada &&
                        currentDetalle.errors.enviada.length > 0,
                    }"
                  />
                  <small
                    v-if="currentDetalle.errors && currentDetalle.errors.enviada"
                    class="form-text text-danger"
                    >{{ currentDetalle.errors.enviada[0] }}</small
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" type="button" @click="agregaDetalle">
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModal1"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div v-if="current.id">
      <LogModalComponent modulo="inv" transac="sal_traslado" :id="current.id" />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PosicionesService from "@/services/inventario/PosicionesService";
import CommonService from "@/services/commons/CommonService";
import DynamicService from "@/services/commons/DynamicService";
import ProductosService from "@/services/catalogos/ProductosService";
import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";
import Notifications from "@/notifications/notifications";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import EntradaTrasladoService from "@/services/inventario/EntradaTrasladoService";
import LogModalComponent from "@/components/commons/LogModalComponent";
import GraficoModalComponent from "@/components/commons/GraficoModalComponent";

export default {
  components: {
    ProductoSelectComponentV2,
    LogModalComponent,
    GraficoModalComponent,
  },
  data() {
    return {
      tipo: [{ tipo: "Traslado" }, { tipo: "Devolucion" }],
      testVal: null,
      current: {
        id: null,
        estado_str: null,
        tienda_origen: "",
        tienda_destino: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        salidatrasladod_set: [],
        tipo_traslado: "T",
      },
      currentDetalleMod: {
        id: null,
        cantidad: 0,
        precio_unitario: 0.0,
        producto: [],
        tarima: "",
        producto_lote: [],
        posicion: "",
        posicion_id: "",
        errors: [],
      },

      productos: [],
      options: [],
      currentDetalle: {
        productolote_set: [],
        cantidad: 0,
        producto: null,
        errors: [],
      },

      posiciones: [],
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    fecha_str: function () {
      let self = this;
      return self.customFormatter(self.current.fecha);
    },
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
      self.formatoFecha();
    });
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });

    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    editarDetalleShowmodal(detalle) {
      let self = this;
      ProductosService.getById(detalle.producto.sku).then((res) => {
        self.currentDetalleMod.productolote_set = res.data.productolote_set;
        self.currentDetalleMod.tarima = detalle.tarima;
        self.currentDetalleMod.posicion = detalle.posicion;
        self.currentDetalleMod.cantidad = detalle.cantidad;
        self.currentDetalleMod.producto_lote = detalle.producto_lote;
        self.currentDetalleMod.id = detalle.id;
        self.currentDetalleMod.producto = detalle.producto;
      });
      PosicionesService.fetch({
        tienda: self.current.tienda,
      }).then((res) => {
        self.posiciones = res.data.results;
      });
      $("#modalModDetailSalida").modal();
    },
    refreshPosiciones() {
      let self = this;
      DynamicService.fetch("cat", "tienda-posicion", {
        tienda: self.current.tienda_origen,
      }).then((res) => {
        self.posiciones = res.data.results;
        if (res.data.results.length > 0) {
          self.currentDetalle.posicion = res.data.results[0].id;
        }
      });
    },
    llenarLote(detalle) {
      let self = this;
      console.log(detalle);
      DynamicService.getById("cat", "productos", detalle.sku).then((res) => {
        self.currentDetalle.productolote_set = res.data.productolote_set;
      });
    },
    formatoFecha() {
      let self = this;
      self.current.fecha = self.current.fecha.replace(/\//g, "-");
    },

    refreshCurrent() {
      let self = this;
      SalidaTrasladoService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.usuario = response.data.usuario.name;
        self.current.tienda_origen = response.data.tienda_origen.codigo;
        self.current.tienda_destino = response.data.tienda_destino.codigo;
        self.current.fecha = self.customFormatter(self.current.fecha);
        self.current.errors = [];
        self.current.tipo_traslado = response.data.tipo_traslado;
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = 0;
      });
    },
    guardar(e) {
      e.preventDefault();
      let self = this;
      let current = Object.assign({}, self.current);
      current.fecha = self.current.fecha.replace(/\//g, "-");
      current.tienda = self.current.tienda;
      SalidaTrasladoService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "inventario-salida_traslado-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),

    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];

      return moment(str_d).format("DD/MM/YYYY");
    },
    showModalAddDetail(detalle) {
      let self = this;
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        self.llenarLote(self.productos[0]);
        self.refreshPosiciones();
      });
      $("#modalAddDetailReqTraslado").modal();
    },

    showModalViewEntradas() {
      let self = this;
      EntradaTrasladoService.fetch({
        salida_traslado_e: self.current.id,
      }).then((res) => {
        self.entradas_traslados = res.data.results[0];
        if (self.entradas_traslados) {
          self.$router.push({
            name: "inventario-entrada_traslado-editar",
            params: { id: self.entradas_traslados.id },
          });
        } else {
          Notifications.alert.error(
            "Error",
            "No existen entradas activas para esta salida"
          );
        }
      });
      //$("#modalAddDetailReqTraslado").modal();
    },

    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
      }
      console.log(det);
      SalidaTrasladoService.addDetail(self.current.id, det)
        .then((response) => {
          Notifications.alert.success(
            "Salida por Traslado",
            "Se ha guardado la Información."
          );
          self.refreshCurrent();
          self.refreshDetalleModDefault();
          self.$refs.cerrarModal1.click();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            self.currentDetalle.errors = error.response.data;
          }
        });
    },

    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Salida por Traslado",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          SalidaTrasladoService.eliminar_linea(detalle.salida_traslado_e, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success(
                "Salida por Traslado",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },

    editarDetalle() {
      let self = this;
      let detMod = Object.assign({}, self.currentDetalleMod);
      if (detMod.posicion != null) {
        if (detMod.posicion.posicion_id) {
          detMod.posicion = detMod.posicion.posicion_id;
        }
      }
      detMod.producto_lote = detMod.producto_lote.id;
      detMod.id = detMod.id;
      detMod.cantidad = detMod.cantidad;
      detMod.tarima = detMod.tarima;
      SalidaTrasladoService.modificar_detalle(self.current.id, detMod)
        .then((response) => {
          Notifications.alert.success(
            "Salida por Traslado",
            "¡Modificación Satisfactoria!"
          );
          self.refreshCurrent();
          self.refreshDetalleModDefault();
          self.$refs.cerrarModal.click();
        })
        .catch((error) => {
          self.currentDetalleMod.errors = error.response.data;
        });
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Salida por Traslado",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          SalidaTrasladoService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Salida por Traslado",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Salida por Traslado",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          SalidaTrasladoService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Salida por Traslado",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Salida por Traslado",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          SalidaTrasladoService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Salida por Traslado",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.entrada_traslado_e
                );
              }
            });
        }
      );
    },
    generar_entrada() {
      let self = this;
      Notifications.alert.confirm(
        "Generar Entrada por Traslado",
        "¿Desea generar el ingreso de los productos en la tienda de destino?",
        "Si, Generar",
        function () {
          SalidaTrasladoService.generar_entrada_traslado(self.current.id)
            .then((response) => {
              Notifications.alert.confirm(
                "Generar entrada de traslado",
                `Ir a la Entrada Generada # ${self.current.numero}`,
                "",
                function () {
                  self.$router.push({
                    name: "inventario-entrada_traslado-editar",
                    params: { id: response.data.salida_traslado_e },
                  });
                }
              );
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Generar entrada de traslado",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Generar entrada de traslado",
                  error.response.data.salida_traslado_e
                );
              }
            });
        }
      );
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshPosiciones();
      // self.refreshUnidadMedida(producto);
    },
    imprimir() {
      let id = this.$route.params.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let user = localStorage.getItem("id_usuario");
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/salidas_traslados/Salidas_Traslados.jrxml&id=${id}&usuario=${user}`
      );
    },
    refreshDetalleModDefault() {
      let self = this;
      (self.currentDetalleMod = {
        id: null,
        cantidad: 0,
        precio_unitario: 0.0,
        producto: [],
        tarima: "",
        producto_lote: [],
        posicion: "",
        posicion_id: "",
        errors: [],
      }),
        (self.currentDetalle = {
          cantidad: "",
          cantidad_um: "",
          unidad_medida: null,
          proveedor: null,
          producto: {
            sku: null,
            unidad_medida: null,
            errors: [],
          },
          errors: [],
        });
    },
  },
};
</script>
